// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountRemoveSiteDefaultResponse {
    static getAttributeTypeMap() {
        return AccountRemoveSiteDefaultResponse.attributeTypeMap;
    }
}
AccountRemoveSiteDefaultResponse.discriminator = undefined;
AccountRemoveSiteDefaultResponse.additionalProperties = false;
AccountRemoveSiteDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountRemoveSiteDefaultResponse.js.map